"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sfSymbolForIconName = void 0;
function sfSymbolForIconName(iconName) {
    return iconName;
}
exports.sfSymbolForIconName = sfSymbolForIconName;
